export default {
  url: 'URL',
  ptDbId: 'ID databázy PT',
};
